import { render, staticRenderFns } from "./CoTwoGroupTransportationForm.vue?vue&type=template&id=3d432d9b&"
import script from "./CoTwoGroupTransportationForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoGroupTransportationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports